import { Component } from '@theme/component';

const RETRY_MS = 500;
const GIVE_UP_MS = 10000;

class EmeCookiePreferences extends Component {
  #timer = null;

  connectedCallback() {
    super.connectedCallback();
    this.#reveal(Date.now());
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    clearTimeout(this.#timer);
  }

  get #api() {
    return typeof window.privacyBanner?.showPreferences === 'function' ? window.privacyBanner : null;
  }

  #reveal(start) {
    if (this.#api) {
      this.closest('[data-eme-cookie-preferences]')?.removeAttribute('hidden');
      return;
    }
    if (Date.now() - start > GIVE_UP_MS) return;
    this.#timer = setTimeout(() => this.#reveal(start), RETRY_MS);
  }

  open() {
    this.#api?.showPreferences();
  }
}

if (!customElements.get('eme-cookie-preferences')) customElements.define('eme-cookie-preferences', EmeCookiePreferences);
